// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"635b4d69","186":"0ba316f2","344":"02f96cc5","372":"755c2dc6","443":"c938b458","738":"2495751e","779":"7a4bf2a7","841":"eaaace9b","856":"df8792ab"}[chunkId] + ".chunk.js";
};